var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',[_vm._v(" You are logged out from your session. ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }